import React from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import { useFilters } from '../../context'

interface Props {
  pages: number
}

export const LoadMore: React.FC<Props> = ({ pages }) => {
  const { page, setPage } = useFilters()

  const loadMore = () => {
    if (page < pages) setPage(page + 1)
  }

  if (page >= pages) return null

  return (
    <VisibilitySensor onChange={loadMore}>
      <button className="productlist-loadmore" onClick={loadMore}>
        <i className="icon-arrowset-1-down"></i>
        <span>Load More</span>
      </button>
    </VisibilitySensor>
  )
}
